import { Contact } from '@trukt/types/Contact';
import { useState } from 'react';
import { ContactOptionFormatter } from '@trukt/ui/ContactOptionFormatter';
import { SelectOption } from '@trukt/ui/SelectOption';
import { useDebounce } from '@trukt/react-hooks/useDebounce';
import { useOptions } from '@trukt/react-hooks/useOptions';
import { Option } from '@trukt/portal-utils/Option';
import { SearchContactInputProps } from './SearchContactInput.types';
import { useContactOptionsQuery } from './hooks';

export type ContactFilterData = {
  label: string;
  value: string;
};

export const SearchContactInput = ({ addOption }: SearchContactInputProps) => {
  const [search, setSearch] = useState<string>('');
  const handleInputChange = useDebounce((inputValue: string) => setSearch(inputValue));

  const contactOptionsQuery = useContactOptionsQuery(search);

  const contactOptions = useOptions(contactOptionsQuery.data?.results, {
    label: 'name',
    value: 'guid',
  });

  const handleChange = (selectedOption: Option<string, Contact>) =>
    addOption(buildContactOption({ label: selectedOption.label, value: selectedOption.value }));

  return (
    <div className="w-[12vw]">
      <SelectOption
        variant="search"
        selectedValueId="" // left empty to avoid the value being selected by default
        aria-label="Search for a contact"
        isLoading={contactOptionsQuery.isFetching}
        onInputChange={handleInputChange}
        options={contactOptions}
        onChange={handleChange}
        optionFormatter={ContactOptionFormatter}
      />
    </div>
  );
};

export function buildContactOption(data: ContactFilterData) {
  return {
    id: data.value,
    label: data.label,
    data,
    stateModifiers: {
      isActive: true,
    },
  };
}
